export const Plus = (props) => {
  const { size = 24, onClick, verticalAlign, marginLeft, marginRight, top, color, className = '' } = props;
  return (
    <span onClick={onClick} className={`icon-wrap ${className}`} style={{ marginLeft, marginRight, top, color }}>
      <svg xmlns='http://www.w3.org/2000/svg' style={{ verticalAlign }} width={size} height={size} fill='none' viewBox='0 0 24 24'>
        <path stroke='currentColor' strokeLinecap='round' strokeWidth='1.5' d='M12 5v7m0 0v7m0-7H5m7 0h7'></path>
      </svg>
    </span>
  );
};
